export const NETWORK_ERROR = '¡Uy! Parece que no estás conectado a internet.';
export const DEFAULT_ERROR = '¡Uy, algo salió mal! Volvé a intentar más tarde.';
export const INACTIVITY_LOGOUT = '¡Tu sesión expiró! Por favor, volvé a iniciar sesión.';
export const LOGIN_DEFAULT_ERROR = '¡Uy, algo salió mal! Volvé a iniciar sesión.';
export const CONECCTION_ERROR = 'Hubo un problema para conectar con el servidor';
export const INVALID_CREDENTIALS = 'El usuario y/o contraseña son incorrectos';
